import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=4a1fbf20&scoped=true&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=4a1fbf20&scoped=true&lang=scss&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./ProductEditor.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fbf20",
  null
  
)

export default component.exports